import React, { FC, memo, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ArrivalStatisticsTotals, ArrivalStatisticsTotal } from 'entities/Warehouse';
import { ArrivalStatisticsCard } from '../ArrivalStatisticsCard';

interface ArrivalsStatisticsCardsProps {
  data?: ArrivalStatisticsTotals;
  isLoading?: boolean;
}

export const ArrivalsStatisticsCards: FC<ArrivalsStatisticsCardsProps> = memo((props) => {
  const { data, isLoading } = props;
  const { t } = useAppTranslation('common');

  const arrivalsLeavingDiff = useMemo<ArrivalStatisticsTotal | null>(() => {
    if (!data) {
      return null;
    }

    return {
      boxAmount: data.arrivals.boxAmount - data.leaving.boxAmount,
      contractRate: data.arrivals.contractRate - data.leaving.contractRate,
      personalContractRateAmount: data.arrivals.personalContractRateAmount - data.leaving.personalContractRateAmount,
      businessContractRateAmount: data.arrivals.businessContractRateAmount - data.leaving.businessContractRateAmount,
      currentBoxRate: data.arrivals.currentBoxRate - data.leaving.currentBoxRate,
      rateDiff: NaN,
      rateDiffPercent: NaN,
      personalAmount: data.arrivals.personalAmount - data.leaving.personalAmount,
      businessAmount: data.arrivals.businessAmount - data.leaving.businessAmount,
      squareAmount: data.arrivals.squareAmount - data.leaving.squareAmount,
      personalSquareAmount: data.arrivals.personalSquareAmount - data.leaving.personalSquareAmount,
      businessSquareAmount: data.arrivals.businessSquareAmount - data.leaving.businessSquareAmount,
    };
  }, [data]);

  if (isLoading || !data) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className="bg-secondaryLight rounded-lg p-6 animate-pulse">
            <div className="h-6 bg-gray-200 rounded mb-4"></div>
            <div className="bg-white rounded-lg p-6 space-y-4">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
      <ArrivalStatisticsCard title={t('Arrivals')} data={data.arrivals} />
      <ArrivalStatisticsCard title={t('Leaving')} data={data.leaving} />
      {arrivalsLeavingDiff && <ArrivalStatisticsCard title={t('Arrivals/Leaving Diff')} data={arrivalsLeavingDiff} isDiff />}
      <ArrivalStatisticsCard title={t('Notice leave')} data={data.noticeLeave} />
    </div>
  );
});
